import { Breadcrumbs, Typography, Link, Stack } from "@mui/material";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import { useCadastroAprovadoresListaViewModel } from "../../viewModels/cadastro_aprovadores_lista_view_model";
import { Header } from "./components/header";
import { AprovadorModal } from "./components/aprovador_modal";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { useMemo } from "react";
import { GenerateFuncionariosAprovadoresColumns } from "./columns";
import { FuncionarioAprovador } from "../../../domain/models/funcionario_aprovador";

import AlertError from "../../../../../common/components/alert_error";
import RefreshButton from "../../../../../common/components/refresh_button";
import PrimaryButton from "../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import DeleteDialog from "../../../../../common/components/delete_dialog";

/**
 * CadastroAprovadoresLista
 */

export const CadastroAprovadoresLista = () => {
  const viewModel = useCadastroAprovadoresListaViewModel();

  const columnsDefinition = useMemo(() => {
    return GenerateFuncionariosAprovadoresColumns({
      onActionDeletar: viewModel.handleFuncionarioAprovadorDeleteOpenState,
      onActionEditar: viewModel.handleAprovadorEdit,
    });
  }, [
    viewModel.handleFuncionarioAprovadorDeleteOpenState,
    viewModel.handleAprovadorEdit,
  ]);

  return (
    <>
      {/**
        * PageTopBar
        */}

      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <div className="w-[10rem]">
                <PrimaryButton
                  startIcon={<DynamicIcon nameIcon="Add" size={20} className="text-white" />}
                  onClick={() => viewModel.handleAprovadorModalOpenState(true)}>
                  Novo Aprovador
                </PrimaryButton>
              </div>
            </div>
          }
        />
      </PageTopBar>

      {/**
        * Page
        */}

      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            Compras
          </Link>
          <Typography className="text-primary-green">
            Cadastro de Aprovadores
          </Typography>
        </Breadcrumbs>

        <div className="flex flex-col gap-2">
          <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
            <div className="flex gap-2 items-center w-full">
              <h1 className="text-3xl font-medium text-black dark:text-white">Cadastro de Aprovadores</h1>
              <RefreshButton onClick={viewModel.handleReload} />
            </div>

            <div className="w-full justify-end flex gap-2">
            </div>
          </div>
        </div>
        {
          viewModel.errorMessage !== undefined
            ? (
              <div className="w-full">
                <AlertError
                  messageErro={viewModel.errorMessage}
                  onTryAgain={viewModel.handleReload} />
              </div>
            ) : (
              <>
                <Header
                  nomeEmailFuncionario={viewModel.filters.nomeEmailFuncionario}
                  centrosCustos={viewModel.filters.centrosCustos}
                  centrosCustoDropdown={viewModel.centrosCustoDropdown}
                  onNomeEmailFuncionarioChange={viewModel.onNomeEmailFuncionarioChange}
                  onCentrosCustoChange={viewModel.handleCentroCustoChange}
                  onClearFilters={viewModel.handleClearFilters}
                />

                <Stack spacing={0}>
                  <StyledDataGrid
                    tableName="funcionarios_aprovadores"
                    disableRowSelectionOnClick={true}
                    disableColumnMenu={false}
                    textSize="pequeno"
                    getRowId={(row: FuncionarioAprovador) => row.idFuncionarioAprovador}
                    getRowHeight={() => 'auto'}
                    columns={columnsDefinition}
                    loading={viewModel.loading}
                    rows={viewModel.funcionarioAprovadores}
                  />
                </Stack>
              </>
            )
        }
      </div>

      {/**
        * Modals
        */}

      <AprovadorModal
        open={viewModel.aprovadorModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        funcionariosAprovacaoDropdown={viewModel.funcionariosAprovacaoDropdown}
        aprovadorEmEdicao={viewModel.aprovadorEmEdicao}
        onClose={() => viewModel.handleAprovadorModalOpenState(false)}
        onSubmit={viewModel.handleAprovadorSubmit}
      />

      <DeleteDialog
        open={viewModel.funcionarioAprovadorDeleteModal}
        saving={viewModel.saving}
        title="Você realmente deseja excluir este item?"
        onClose={() => viewModel.handleFuncionarioAprovadorDeleteOpenState(0, false)}
        onDelete={viewModel.handleFuncionarioAprovadorDeleteSubmit}
      />
    </>
  );
}
